import React, { useState, useEffect } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

export const TYPES = {
  INFO: 'info',
  CONFIRM: 'confirm',
  SUCCESS: 'success',
  ERROR: 'error',
}

export const useAlert = () => {

  const [sweetAlert, setSweetAlert] = useState();
  const [action, setAction] = useState();

  const renderErrorAlert = (title = null, message = null) => {

    return (
      <SweetAlert
        danger
        title={title || 'Opss...'}
        onConfirm={() => setSweetAlert(null)}
      >
        {message || 'Somenthing wrong'}
      </SweetAlert>
    )
  }

  const renderSuccessAlert = (title = null, message = null) => {

    return (
      <SweetAlert
        success
        title={title || 'Success...'}
        onConfirm={() => setSweetAlert(null)}
      >
        {message || 'Congratulation.'}
      </SweetAlert>
    )
  }

  const handleAlert = async () => {

    switch (action.type) {
      case TYPES.INFO:
        return setSweetAlert(
          <SweetAlert
            info
            title={action.payload.title}
            confirmBtnBsStyle="info"
            onConfirm={() => setSweetAlert(null)}
          >
            {action.payload.message}
          </SweetAlert>
        );

      case TYPES.CONFIRM:

        const handleConfirm = async () => {

          try {

            await action.payload.onSuccess.callback();

            setSweetAlert(
              renderSuccessAlert(
                action.payload.onSuccess.title,
                action.payload.onSuccess.message
              )
            );

          } catch (error) {

            if (action.payload.onError?.callback !== undefined)
              await action.payload.onError.callback();


            if (error.response) {
              if(error.response.data.message.includes('integrity constraint')){

                return setSweetAlert(
                  renderErrorAlert(
                    'Opss...',
                    "Can't delete data because already used"
                  )
                );
              }
              return setSweetAlert(
                renderErrorAlert(
                  error.response.statusText,
                  error.response.data.name
                )
              );
            }

            setSweetAlert(
              renderErrorAlert(
                action.payload.onError?.title,
                error
              )
            );
          }
        }

        return setSweetAlert(
          <SweetAlert
            warning
            showCancel
            title={action.payload.title}
            onConfirm={handleConfirm}
            onCancel={() => setSweetAlert(null)}
          >
            {action.payload.message}
          </SweetAlert>
        );

      case TYPES.SUCCESS:
        return setSweetAlert(
          renderSuccessAlert(
            action.payload.title,
            action.payload.message
          )
        );

      case TYPES.ERROR:
        return setSweetAlert(
          renderErrorAlert(
            action.payload.title,
            action.payload.message
          )
        );

      default:
        break;
    }
  }

  useEffect(() => {

    if (action) handleAlert();
    return () => {
      // console.log(`cleanup`);
    }

  }, [action]);


  return [sweetAlert, setAction];
}

